import React, { useState } from 'react'
import { IonButton, IonCol, IonContent, IonGrid, IonRow, } from '@ionic/react'
import { SafetyPadding } from '../../components/SafetyPadding';
import { CreateWalkInterface } from './CreatePage';
import Api from '../../services/Api';

interface ComponentProps {
  walk: CreateWalkInterface
  setWalk: React.Dispatch<CreateWalkInterface>
  slideNext: Function
  cancelCreate: Function
}

const CreateGroup = ({walk, setWalk, slideNext, cancelCreate}: ComponentProps) => {
  const api = Api.getInstance()
  const [pickedNumber, setPickedNumber] = useState('4')
  const setNumber = "circle_large background_teal flex justify-center items-center"
  const notSetNumber = "circle_large background_smoke flex justify-center items-center"

  const personHandler = (e: any) => {
    setPickedNumber(e.target.id)
    setWalk(({...walk, max_bookings: parseInt(e.target.id)}))
  }
  
  return (
    <IonContent>
      <IonGrid>
        <h1 className="color_blue text_center mt-16">
          {api.tr('availablespots')}
        </h1>
        <IonRow className="mt-6 flex justify-evenly">
          <IonCol>
            <IonCol id="1" className={pickedNumber === '1' ? setNumber : notSetNumber } onClick={(e) => personHandler(e)}>1</IonCol>
          </IonCol>
          <IonCol>
            <IonCol id="2" className={pickedNumber === '2' ? setNumber : notSetNumber } onClick={(e) => personHandler(e)}>2</IonCol>
          </IonCol>
          <IonCol >
            <IonCol id="3" className={pickedNumber === '3' ? setNumber : notSetNumber } onClick={(e) => personHandler(e)}>3</IonCol>
          </IonCol>
          <IonCol >
            <IonCol id="4" className={pickedNumber === '4' ? setNumber : notSetNumber } onClick={(e) => personHandler(e)}>4</IonCol>
          </IonCol>
        </IonRow>
        <IonRow className="mt-6 flex justify-evenly">
          <IonCol >
            <IonCol id="5" className={pickedNumber === '5' ? setNumber : notSetNumber } onClick={(e) => personHandler(e)}>5</IonCol>
          </IonCol>
          <IonCol >
            <IonCol id="6" className={pickedNumber === '6' ? setNumber : notSetNumber } onClick={(e) => personHandler(e)}>6</IonCol>
          </IonCol>
          <IonCol >
            <IonCol id="7" className={pickedNumber === '7' ? setNumber : notSetNumber } onClick={(e) => personHandler(e)}>7</IonCol>
          </IonCol>
          <IonCol>
            <IonCol id="8" className={pickedNumber === '8' ? setNumber : notSetNumber } onClick={(e) => personHandler(e)}>8</IonCol>
          </IonCol>
        </IonRow>

      <IonRow className="mt-6">
          <IonButton 
            onClick={() => slideNext()}
            expand="block" 
            className="m-2 fullWidth">
            {api.tr('ContinueNext_page')}
          </IonButton>
        </IonRow>
        <IonRow>
          <IonButton 
            onClick={() => {
              cancelCreate()
            }}
            expand="block" 
            fill="clear"
            className="m-2 fullWidth">
            {api.tr('cancel')}
          </IonButton>
        </IonRow>
      </IonGrid>
      <SafetyPadding/>
    </IonContent>
  )
}

export default CreateGroup